// extracted by mini-css-extract-plugin
module.exports =  {"headline":"lqgCFC","totals":"uzbgvO","deliveryLine":"qhTeVm","line":"VichYS","destinationPickerOnly":"Nzs7yp","divider":"sRIWuY","cartSummary":"Q0uCMB"};